import { render, staticRenderFns } from "./EventHistoryDay.vue?vue&type=template&id=ea630b6e&"
import script from "./EventHistoryDay.vue?vue&type=script&lang=ts&"
export * from "./EventHistoryDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports